// material-ui
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { ResolvePath } from 'features/firebase-app'
import { useNavigate } from 'react-router-dom'

import { Typography } from '@mui/material'
import { IconEdit, IconUserPlus } from '@tabler/icons'
import TitleService from 'title-service'

import { Views } from 'features/enumerations'

// assets

import { useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  const navigate = useNavigate()
  const customization = useSelector((state: any) => state.customization)

  function viewprofilecommandcomponent(comp: any): any {
    return (
      <>
        <div>
          <List>
            <ListItemButton
              sx={{ borderRadius: `${customization.borderRadius}px` }}
              onClick={() => {
                navigate(ResolvePath(Views.AddProfile))
              }}
            >
              <ListItemIcon>
                <IconUserPlus stroke={1.5} size="2.3rem" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography variant="h3">
                    {TitleService('Add Profile')}
                  </Typography>
                }
              />
            </ListItemButton>
            <ListItemButton
              sx={{ borderRadius: `${customization.borderRadius}px` }}
              onClick={() => {
                navigate(ResolvePath(Views.EditProfileSelect))
              }}
            >
              <ListItemIcon>
                <IconEdit stroke={1.5} size="2.3rem" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography variant="h3">
                    {TitleService('Edit Profiles')}
                  </Typography>
                }
              />
            </ListItemButton>
          </List>
        </div>
      </>
    )
  }

  let output_viewprofilecommandcomponent = viewprofilecommandcomponent(null)

  return output_viewprofilecommandcomponent
}
